// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { RegistrarServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { ERR_ACC_REGISTRAR_SVC, SUC_ACC_REGISTRAR_SVC } from '../../../../utils/strings';

export const useAcceptRegistrarServiceRequest = () => {
  const { submit } = useExerciseSubmission(
    RegistrarServiceRequest.RegistrarServiceRequest_Accept,
    SUC_ACC_REGISTRAR_SVC,
    ERR_ACC_REGISTRAR_SVC,
  );
  return submit;
};
